import React from 'react';

class SaleOrderAjaxSuccess extends React.Component{
    render() {

        let date = sessionStorage.getItem('date') || false;
        let customerName = sessionStorage.getItem('customerName') || false;
        let orderId = sessionStorage.getItem('orderId') || false;

        if (orderId === this.props.match.params.order_id && date && customerName){
            return (
                <div>
                    <h2>Заказ сформирован</h2>
                    <div>
                        <strong>Уважаемый (-ая) {customerName}!</strong><br/><br/>

                        Благодарим Вас за оформленный заказ № {orderId} от {date}.<br/>
                        Подробную информацию о заказе мы выслали на указанную Вами электронную почту.<br/>
                        Если в течение 30 минут после оформления заказа мы Вам не перезвонили, убедительно просим проверить указанный Вами номер телефона и связаться с нами.<br/>
                    </div>
                </div>
            );
        } else {
            window.location.href = '/catalog/';
        }


    }
}

export default SaleOrderAjaxSuccess;